import React from "react";
import { MimaButton, MimaDropdown, MimaText, MimaTextArea, Modal } from "../../components";
import styles from "../../assets/styles/SignedUpBusinesses/SignedUpBusinesses.module.scss";
import { Formik } from "formik";
import moment from "moment";

const ViewMore = ({
    data,
    closeModal,
    setInfoModal,
    infoModal,
    onSubmit,
    loading,
}) => {

    return (
        <Modal closeModal={closeModal}>
            <>
                {infoModal === "stage1" && (
                    <div className={styles.modal_section}>

                        <MimaText variant="subtitleBold" mb={3} align="center">Business Information</MimaText>
                        <MimaText labelTitle="Full Name">{data.users?.[0].firstname} {data.users?.[0].lastname}</MimaText>
                        <MimaText labelTitle="Business Name">{data.tradingName}</MimaText>
                        <MimaText labelTitle="Business Phone Number">{data.mobile}</MimaText>
                        <MimaText labelTitle="Business Email">{data.email}</MimaText>
                        <MimaText labelTitle="Created Date">{data.createdAt}</MimaText>
                        {data?.businessRegNum && <MimaText labelTitle="Business Registration Number">{data?.businessRegNum}</MimaText>}
                        {data?.website && <MimaText labelTitle="Website Address">{data?.website}</MimaText>}
                        {data.instagramHandle && <MimaText labelTitle="Instagram Handle">{data.instagramHandle}</MimaText>}
                        {data?.twitterHandle && <MimaText labelTitle="Twitter Handle">{data?.twitterHandle}</MimaText>}
                        {data?.referredBy && <MimaText labelTitle="Referred By">{data?.referredBy}</MimaText>}
                        {data?.referralSource && <MimaText labelTitle="How did you hear of us">{data?.referralSource}</MimaText>}
                        {data?.businessAddress && <MimaText labelTitle="Business Address">{data?.businessAddress}</MimaText>}
                        <MimaText labelTitle="Business Approval Status">{data.status}</MimaText>
                        <MimaText labelTitle="Business Activity Status">{data.activityStatus}</MimaText>
                        {data?.reason && <MimaText labelTitle={`${data.status === 'INACTIVE' ? 'Suspension' : 'Approval'} Reason`}>{data?.reason}</MimaText>}
                        {data?.referralCode && <MimaText labelTitle="Referred by">{data?.referralCode}</MimaText>}
                        {data?.users[0]?.lastLoginDate && <MimaText labelTitle="Last Login Date">{data?.users[0]?.lastLoginDate}</MimaText>}
                        {data?.subscription && (
                            <>
                                {data?.subscription.amountPaid !== 0 ? (<>
                                    <MimaText labelTitle="Subscription Plan">{data?.plan.name}</MimaText>
                                    <MimaText labelTitle="Months Subscribed">{data?.subscription.months} Month(s)</MimaText>
                                    <MimaText labelTitle="Subscription Expiry">{moment(data?.subscription?.expiryDate).format("DD/MM/YY")}</MimaText>
                                    <MimaText labelTitle="Subscription Status">{data?.subscription?.status}</MimaText>
                                </>) : (
                                    <>
                                        <MimaText labelTitle="Subscription Plan">ON TRIAL</MimaText>
                                        <MimaText labelTitle="Trial Expiry">{moment(data?.subscription?.expiryDate).format("DD/MM/YY")}</MimaText>
                                        <MimaText labelTitle="Trial Status">{data?.subscription?.status}</MimaText>
                                    </>)}
                            </>
                        )}


                        <MimaButton
                            title={data.status === "INACTIVE" ? "APPROVE" : "SUSPEND"}
                            width={38}
                            buttonColor="var(--color-dark)"
                            mt={5}
                            onClick={() => {
                                setInfoModal("stage2");
                            }}
                        />
                    </div>


                )}
                {infoModal === "stage2" && (

                    <Formik
                        initialValues={{
                            status: data?.status || "",
                            reason: "",
                        }}
                        onSubmit={onSubmit}
                    // validationSchema={validateYupSchema}
                    >
                        {({ handleBlur,
                            handleChange,
                            setFieldValue,
                            values,
                            handleSubmit }) => (
                            <>
                                <MimaText width="38" align="center" mb="5" variant="subtitle" color="#4A4A68">{data.tradingName}</MimaText>
                                <MimaText width="38" align="center" mb="3">Currently {data.status}. Select status below to make it {data.status === "INACTIVE" ? "ACTIVE" : "INACTIVE"}</MimaText>
                                <MimaDropdown
                                    labelTitle="Status"
                                    placeholder="Select Status"
                                    name="status"
                                    value={values.status}
                                    id="status"
                                    data={[
                                        { value: "BLOCKED", key: "BLOCKED" },
                                        { value: "ACTIVE", key: "ACTIVE" }
                                    ]}
                                    onChange={data => {
                                        setFieldValue('status', data.key);
                                    }}
                                />
                                <MimaTextArea
                                    variant="message"
                                    placeholder="Input Reason"
                                    name="reason"
                                    value={values.reason}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <MimaButton
                                    title="Update"
                                    type="submit"
                                    onClick={handleSubmit}
                                    mt={2}
                                    width="38"
                                    buttonColor="#60607A"
                                    loading={loading}
                                />
                            </>
                        )}

                    </Formik>
                )}
            </>
        </Modal>
    )
}
export default ViewMore;